<div
  class="flex items-center rounded-full px-3 py-1 whitespace-nowrap"
  [ngClass]="background()">
  <img
    src="https://superlikers-themes.s3.us-east-1.amazonaws.com/tonicorp/coins.webp"
    alt="Coins"
    class="h-3.5 w-5.5" />
  <p
    class="font-barlow ml-1 text-center text-sm leading-5 font-bold tracking-normal"
    [ngClass]="color()">
    {{ points() }} pts
  </p>
</div>
